export default __webpack_public_path__ + "static/media/headshot-akshay.3b79f8a6.jpeg";